// import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
// import {
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalFooter,
//    ModalBody,
//    ModalCloseButton,
//    Button,
//    FormControl,
//    FormLabel,
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Flex,
//    Switch,
//    Box,
// } from '@chakra-ui/react';
// import { useDispatch } from 'react-redux';
// import { getReportStockDetail } from '../../../../../redux/actions/GlobalIMEI';
// import moment from 'moment';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { useUser } from 'contexts/UserContext';
// import InputField from 'components/ui/InputField';
// import { toast } from 'react-toastify';
// import { hasPurchase } from 'utils/util';

// const SerialNumberModal = ({
//    isOpen,
//    onClose,
//    selectedDaybook,
//    handleStock,
//    itemStocks,
//    itemId,
//    onCloseComplete,
//    setItemStocks,
//    removeStock,
//    warehouseList,
//    lineitemview,
//    selectcompany,
//    textColor,
//    selectdaybookdata,
//    lineitem,
//    headerId,
// }) => {
//    const dispatch = useDispatch();

//    const [rows, setRows] = useState([]);
//    const [serial, setSerial] = useState([]);
//    const [otherSerial, setOtherSerial] = useState([]);
//    const [errors, setErrors] = useState({});
//    const [isLoading, setIsLoading] = useState(false);
//    const lastSearchRef = useRef('');
//    const debounceTimeout = useRef(null);
//    const { user } = useUser();

//    const serialNoRef = useRef([]);
//    const serialNo2Ref = useRef([]);
//    const note1Ref = useRef([]);
//    const submitRef = useRef(null);
//    const plusRef = useRef([]);

//    const isSerialNo = useMemo(() => {
//       if (rows.length === 0) return false;
//       return rows.every((item) => item.serialNo);
//    }, [rows]);

//    const addRow = () => {
//       setRows([
//          ...rows,
//          {
//             id: null,
//             serialNo: '',
//             serialNo2: '',
//             barcode: '',
//             note1: '',
//             isOld: selectedDaybook?.isOld ? true : false,
//             warehouseId: selectdaybookdata?.wareHouseId ?? null,
//          },
//       ]);
//    };

//    const removeRow = (index) => {
//       const lastData = rows.filter((_, i) => i !== index);
//       setRows(lastData);
//       setItemStocks(lastData);
//       removeStock(rows[index]);
//    };

//    const handleOnClose = () => {
//       setRows([
//          {
//             id: null,
//             serialNo: '',
//             serialNo2: '',
//             barcode: '',
//             note1: '',
//             isOld: selectedDaybook?.isOld,
//             warehouseId: null,
//          },
//       ]);
//       setSerial([]);
//       onClose();
//    };

//    const handleSave = () => {
//       const filteredRows = rows.filter((row) => row.serialNo.trim() !== '');
//       handleStock(filteredRows);
//       handleOnClose();
//       setRows([
//          {
//             id: null,
//             serialNo: '',
//             serialNo2: '',
//             barcode: '',
//             note1: '',
//             isOld: selectedDaybook?.isOld,
//             warehouseId: null,
//          },
//       ]);
//    };

//    useEffect(() => {
//       if (itemStocks?.length > 0) {
//          setRows(itemStocks);
//       }
//    }, [itemStocks]);

//    useEffect(() => {
//       if (lineitem?.length > 0) {
//          const allserial = lineitem?.map((li) => li?.stock?.map((stock) => stock?.serialNo)).flat();

//          setOtherSerial(allserial);
//       }
//    }, [isOpen]);

//    useEffect(() => {
//       if (selectedDaybook) {
//          setRows([
//             {
//                id: null,
//                serialNo: '',
//                serialNo2: '',
//                barcode: '',
//                note1: '',
//                isOld: selectedDaybook?.isOld,
//                warehouseId: null,
//             },
//          ]);
//       }
//    }, [selectedDaybook]);

//    useEffect(() => {
//       if (selectcompany?.setting?.warehouseWishStock === true) {
//          if (lineitemview === true) {
//             setRows((prevRows) =>
//                Array.isArray(prevRows)
//                   ? prevRows.map((row) => ({
//                        ...row,
//                        warehouseId:
//                           row.warehouseId === null
//                              ? selectdaybookdata?.wareHouseId
//                                 ? selectdaybookdata?.wareHouseId
//                                 : selectcompany?.setting?.warehouseId
//                                 ? selectcompany?.setting?.warehouseId
//                                 : 1
//                              : 1,
//                     }))
//                   : [],
//             );
//          }
//       }
//    }, [isOpen]);

//    const handleSearch = useCallback(
//       async (value, idx) => {
//          setIsLoading(true);
//          lastSearchRef.current = value;
//          const params = {
//             companyIds: user?.loginhistory?.companyId,
//             fromDate: '2024-01-01',
//             toDate: moment().add(1, 'days').format('YYYY-MM-DD'),
//             stockStatus: 2,
//             serialNo: value,
//             // itemIds: itemId,
//             headerId: headerId,
//          };
//          const newRows = [...rows];
//          const res = await dispatch(getReportStockDetail(params));
//          if (res.code === 1 && res.data?.length > 0 && !hasPurchase(res?.data, Number(headerId || 0))) {
//             newRows[idx]['serialNo'] = '';
//             setRows(newRows);
//             setIsLoading(false);
//          }
//          if (res.code === 2) {
//             newRows[idx]['serialNo'] = '';
//             setRows(newRows);
//             setIsLoading(false);
//          }
//          setIsLoading(false);
//          return res;
//       },
//       [dispatch, headerId, rows, user?.loginhistory?.companyId],
//    );

//    const handleChange = async (e, index) => {
//       const { name, value, type, checked } = e.target;
//       setIsLoading(true);
//       const newRows = [...rows];
//       newRows[index][name] = type === 'checkbox' ? checked : value;

//       const newErrors = { ...errors };
//       if (name === 'serialNo') {
//          if (value.trim() !== '' && value.trim()?.length < 10) {
//             newErrors[`serialNo_${index}`] = 'Serial number must be at least 10 characters.';
//          } else {
//             delete newErrors[`serialNo_${index}`];
//          }
//          setErrors(newErrors);
//       }

//       if (name === 'serialNo' && value.trim() !== '' && value.trim()?.length >= 10) {
//          if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
//          debounceTimeout.current = setTimeout(async () => {
//             await handleSearch(value.trim(), index);

//             const trimmedValue = value.trim();

//             const isDuplicate = serial.includes(trimmedValue);

//             if (isDuplicate) {
//                toast.error(`Duplicate serial number: ${trimmedValue}`);
//                newRows[index][name] = '';
//                return;
//             }
//          }, 500);
//       }
//       if (name === 'serialNo' && value.trim() !== '' && value.trim()?.length >= 10) {
//          if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
//          debounceTimeout.current = setTimeout(async () => {
//             await handleSearch(value.trim(), index);

//             const trimmedValue = value.trim();

//             const isDuplicate = otherSerial.includes(trimmedValue);

//             if (isDuplicate) {
//                toast.error(`Duplicate serial number: ${trimmedValue}`);
//                newRows[index][name] = '';
//                return;
//             }
//          }, 500);
//       }
//       setIsLoading(false);
//       setRows(newRows);
//       if (name === 'serialNo') {
//          // delete errors[key];
//          // setErrors(errors);
//          setTimeout(() => {
//             setSerial((prev) => {
//                const updated = [...prev];
//                updated[index] = value;
//                return updated;
//             });
//          }, 600);
//       }
//    };

//    const handlewarehouseChange = async (name, value, index) => {
//       setIsLoading(true);
//       const newRows = [...rows];
//       newRows[index][name] = value;
//       if (name === 'serialNo' && value.trim() !== '' && value.trim()?.length > 10) {
//          if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
//          debounceTimeout.current = setTimeout(async () => {
//             await handleSearch(value.trim(), index);
//          }, 500);
//       }
//       setIsLoading(false);
//       setRows(newRows);
//    };

//    const handleKeyDown = (e, nextRef, preRef, index) => {
//       if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
//          e.preventDefault();
//          const serialNumber = e.target.value.trim();
//          const name = e.target.name;
//          if (name === 'serialNo' && serialNumber === '') {
//             const lastData = rows.filter((_, i) => i !== index);
//             setRows(lastData);
//             setItemStocks(lastData);
//             submitRef.current.disabled = false;
//             submitRef.current.focus();
//             return;
//          }
//          if (name === 'note1') {
//             if (nextRef && nextRef?.current) {
//                nextRef?.current?.focus();
//                return;
//             }
//          }
//          if (nextRef && nextRef?.current) {
//             nextRef?.current[index]?.focus();
//             return;
//          }
//       }
//       if (e.key === 'Tab' && e.shiftKey) {
//          e.preventDefault();
//          const serialNumber = e.target.value.trim();
//          const name = e.target.name;
//          if (name === 'serialNo' && preRef?.current[index - 1]) {
//             preRef.current[index - 1].focus();
//             return;
//          }
//          if (preRef && preRef?.current) {
//             preRef?.current[index]?.focus();
//             return;
//          }
//       }
//    };

//    const handleKeyDownSerial = (e, index) => {
//       const allowedKeys = [
//          'Backspace',
//          'Tab',
//          'Enter',
//          'Escape',
//          'ArrowLeft',
//          'ArrowRight',
//          'ArrowUp',
//          'ArrowDown',
//          'Delete',
//          'Shift',
//          'Control',
//          'Alt',
//          'Meta',
//          'CapsLock',
//          'Fn',
//          'F1',
//          'F2',
//          'F3',
//          'F4',
//          'F5',
//          'F6',
//          'F7',
//          'F8',
//          'F9',
//          'F10',
//          'F11',
//          'F12',
//          ' ',
//       ];

//       const regex = /^[a-zA-Z0-9]$/; // Only letters and numbers allowed
//       if (!regex.test(e.key) && !allowedKeys.includes(e.key)) {
//          e.preventDefault(); // Stop typing the invalid character
//          handleChange({ target: { name: 'serialNo', value: '' } }, index); // Clear input
//          alert('Only letters and numbers are allowed');
//       }
//    };

//    return (
//       <>
//          <Modal isOpen={isOpen} onClose={handleOnClose} size="6xl" isCentered onCloseComplete={onCloseComplete}>
//             <ModalOverlay />
//             <ModalContent
//                bg={useColorModeValue('white', '#2d3748')}
//                color={useColorModeValue('gray.800', 'white')}
//                borderRadius="20px"
//                p={5}
//                boxShadow="lg">
//                <ModalHeader fontSize="20px" fontWeight="600" mb={4}>
//                   Add Serial Number
//                </ModalHeader>
//                <ModalCloseButton />
//                <ModalBody>
//                   <Box width="100%">
//                      {rows?.map((row, index) => (
//                         <Box
//                            key={index}
//                            border="1px solid"
//                            borderColor="gray.200"
//                            p="20px"
//                            borderRadius="md"
//                            mb={4}
//                            width="100%">
//                            <Grid display="flex" gap={5} width="100%">
//                               <GridItem gap={3} width="100%">
//                                  <GridItem gap={3} display="flex" width="100%">
//                                     <GridItem mb={3} width="50%">
//                                        <InputField
//                                           ref={(el) => (serialNoRef.current[index] = el)}
//                                           type="text"
//                                           name="serialNo"
//                                           errorName={`serialNo_${index}`}
//                                           label="Serial NO"
//                                           value={row.serialNo}
//                                           onChange={(e) => handleChange(e, index)}
//                                           onKeyDown={(e) => {
//                                              handleKeyDown(e, serialNo2Ref, note1Ref, index);
//                                              handleKeyDownSerial(e, index);
//                                           }}
//                                           autoFocus={index === rows?.length - 1}
//                                           errors={errors}
//                                        />
//                                     </GridItem>
//                                     <GridItem width="50%">
//                                        <InputField
//                                           ref={(el) => (serialNo2Ref.current[index] = el)}
//                                           type="text"
//                                           name="serialNo2"
//                                           label="Serial NO 2"
//                                           value={row.serialNo2}
//                                           onChange={(e) => handleChange(e, index)}
//                                           onKeyDown={(e) => handleKeyDown(e, note1Ref, serialNoRef, index)}
//                                           // autoFocus={index === rows?.length - 1}
//                                        />
//                                     </GridItem>
//                                  </GridItem>
//                                  <GridItem display="flex">
//                                     <GridItem
//                                        width="100%"
//                                        mr={
//                                           selectcompany?.setting?.warehouseWishStock === true && lineitemview === true
//                                              ? 3
//                                              : 0
//                                        }>
//                                        <InputField
//                                           ref={(el) => (note1Ref.current[index] = el)}
//                                           type="text"
//                                           name="note1"
//                                           label="Note"
//                                           value={row.note1}
//                                           onChange={(e) => {
//                                              handleChange(e, index);
//                                           }}
//                                           onKeyDown={(e) => handleKeyDown(e, plusRef, serialNo2Ref, index)}
//                                        />
//                                     </GridItem>
//                                     {selectcompany?.setting?.warehouseWishStock === true && lineitemview === true && (
//                                        <GridItem className="seperator-width">
//                                           {renderDynamicDropdown(
//                                              'warehouseId',
//                                              'Ware House',
//                                              warehouseList,
//                                              {
//                                                 value: row.warehouseId,
//                                                 onChange: (value) => handlewarehouseChange('warehouseId', value, index),
//                                                 showCustomNoOptions: true,
//                                                 openfrom: 'wareHouse',
//                                                 // ref: wareHouseRef,
//                                              },
//                                              {},
//                                              textColor,
//                                              false,
//                                              'Select Ware House',
//                                           )}
//                                        </GridItem>
//                                     )}
//                                  </GridItem>
//                               </GridItem>
//                               <GridItem>
//                                  <FormControl display="flex" alignItems="center" mb={3}>
//                                     <FormLabel htmlFor={`idOld-${index}`} style={{ textWrap: 'nowrap' }}>
//                                        Is Old
//                                     </FormLabel>
//                                     <Switch
//                                        name="isOld"
//                                        id={`idOld-${index}`}
//                                        isChecked={row.isOld}
//                                        // defaultChecked={selectedDaybook?.isOld}
//                                        onChange={(e) => handleChange(e, index)}
//                                     />
//                                  </FormControl>
//                                  {rows?.length > 1 && (
//                                     <Button
//                                        colorScheme="red"
//                                        size="sm"
//                                        onClick={() => removeRow(index)}
//                                        _focus={{ outlineColor: 'blue.500' }}>
//                                        -
//                                     </Button>
//                                  )}
//                                  {index === rows?.length - 1 && (
//                                     <Button
//                                        ref={plusRef}
//                                        colorScheme="green"
//                                        size="sm"
//                                        onClick={addRow}
//                                        _focus={{ outlineColor: 'blue.500' }}>
//                                        +
//                                     </Button>
//                                  )}
//                               </GridItem>
//                            </Grid>
//                         </Box>
//                      ))}
//                   </Box>
//                </ModalBody>
//                <ModalFooter justifyContent="flex-end" alignItems="center">
//                   <Flex>
//                      <Button
//                         ref={submitRef}
//                         colorScheme="blue"
//                         ml={3}
//                         width="100%"
//                         onClick={() => handleSave()}
//                         _focus={{ outlineColor: 'blue.500' }}
//                         isDisabled={isLoading || !isSerialNo} // || !isSerialNo
//                         isLoading={isLoading}>
//                         Save
//                      </Button>
//                      <Button colorScheme="red" onClick={() => handleOnClose()} ml={3} width="100%">
//                         Cancel
//                      </Button>
//                   </Flex>
//                </ModalFooter>
//             </ModalContent>
//          </Modal>
//       </>
//    );
// };

// export default SerialNumberModal;

import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   Button,
   FormControl,
   FormLabel,
   Grid,
   GridItem,
   useColorMode,
   Flex,
   Switch,
   Box,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { getReportStockDetail } from '../../../../../redux/actions/GlobalIMEI';
import moment from 'moment';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { useUser } from 'contexts/UserContext';
import InputField from 'components/ui/InputField';
import { toast } from 'react-toastify';
import { hasPurchase } from 'utils/util';

const SerialNumberModal = ({
   isOpen,
   onClose,
   selectedDaybook,
   handleStock,
   itemStocks,
   itemId,
   onCloseComplete,
   setItemStocks,
   removeStock,
   warehouseList,
   lineitemview,
   selectcompany,
   textColor,
   selectdaybookdata,
   lineitem,
   headerId,
}) => {
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [rows, setRows] = useState([]);
   const [serial, setSerial] = useState([]);
   const [otherSerial, setOtherSerial] = useState([]);
   const [errors, setErrors] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const [isSaving, setIsSaving] = useState(false);
   const lastSearchRef = useRef('');
   const debounceTimeout = useRef(null);
   const { user } = useUser();

   const serialNoRef = useRef([]);
   const serialNo2Ref = useRef([]);
   const note1Ref = useRef([]);
   const submitRef = useRef(null);
   const plusRef = useRef([]);
   // const isOldRef = useRef([]);
   // const isBoxRef = useRef([]);
   // const isBillRef = useRef([]);
   // const isKitRef = useRef([]);

   const isSerialNo = useMemo(() => {
      if (rows.length === 0) return false;
      return rows.every((item) => item.serialNo);
   }, [rows]);

   const addRow = () => {
      setRows([
         ...rows,
         {
            id: null,
            serialNo: '',
            serialNo2: '',
            barcode: '',
            note1: '',
            isOld: selectedDaybook?.isOld ? true : false,
            warehouseId: selectdaybookdata?.wareHouseId ?? null,
            isBox: false,
            isBill: false,
            isKit: false,
         },
      ]);
   };

   const removeRow = (index) => {
      const lastData = rows.filter((_, i) => i !== index);
      setRows(lastData);
      setItemStocks(lastData);
      removeStock(rows[index]);
   };

   const handleOnClose = () => {
      setRows([
         {
            id: null,
            serialNo: '',
            serialNo2: '',
            barcode: '',
            note1: '',
            isOld: selectedDaybook?.isOld,
            warehouseId: null,
            isBox: false,
            isBill: false,
            isKit: false,
         },
      ]);
      setSerial([]);
      onClose();
   };

   const handleSave = async () => {
      if (isSaving) return;

      setIsSaving(true);

      try {
         const filteredRows = rows.filter((row) => row.serialNo.trim() !== '');
         console.log('filteredRows', filteredRows);
         await handleStock(filteredRows);
         handleOnClose();
         setRows([
            {
               id: null,
               serialNo: '',
               serialNo2: '',
               barcode: '',
               note1: '',
               isOld: selectedDaybook?.isOld,
               isBox: false,
               isBill: false,
               isKit: false,
               warehouseId: null,
            },
         ]);
      } catch (error) {
         console.error('Error saving serial numbers:', error);
      } finally {
         setIsSaving(false);
      }
   };

   useEffect(() => {
      if (itemStocks?.length > 0) {
         setRows(itemStocks);
      }
   }, [itemStocks]);

   useEffect(() => {
      if (lineitem?.length > 0) {
         const allserial = lineitem?.map((li) => li?.stock?.map((stock) => stock?.serialNo)).flat();

         setOtherSerial(allserial);
      }
   }, [isOpen]);

   useEffect(() => {
      if (selectedDaybook) {
         setRows([
            {
               id: null,
               serialNo: '',
               serialNo2: '',
               barcode: '',
               note1: '',
               isOld: selectedDaybook?.isOld,
               warehouseId: null,
               isBox: false,
               isBill: false,
               isKit: false,
            },
         ]);
      }
   }, [selectedDaybook]);

   useEffect(() => {
      if (selectcompany?.setting?.warehouseWishStock === true) {
         if (lineitemview === true) {
            setRows((prevRows) =>
               Array.isArray(prevRows)
                  ? prevRows.map((row) => ({
                     ...row,
                     warehouseId:
                        row.warehouseId === null
                           ? selectdaybookdata?.wareHouseId
                              ? selectdaybookdata?.wareHouseId
                              : selectcompany?.setting?.warehouseId
                                 ? selectcompany?.setting?.warehouseId
                                 : 1
                           : 1,
                  }))
                  : [],
            );
         }
      }
   }, [isOpen]);

   const handleSearch = useCallback(
      async (value, idx) => {
         setIsLoading(true);
         lastSearchRef.current = value;
         const params = {
            companyIds: user?.loginhistory?.companyId,
            fromDate: '2024-01-01',
            toDate: moment().add(1, 'days').format('YYYY-MM-DD'),
            stockStatus: 2,
            serialNo: value,
            // itemIds: itemId,
            headerId: headerId,
         };
         const newRows = [...rows];
         const res = await dispatch(getReportStockDetail(params));
         if (res.code === 1 && res.data?.length > 0 && !hasPurchase(res?.data, Number(headerId || 0))) {
            newRows[idx]['serialNo'] = '';
            setRows(newRows);
            setIsLoading(false);
         }
         if (res.code === 2) {
            newRows[idx]['serialNo'] = '';
            setRows(newRows);
            setIsLoading(false);
         }
         setIsLoading(false);
         return res;
      },
      [dispatch, headerId, rows, user?.loginhistory?.companyId],
   );

   const handleChange = async (e, index) => {
      const { name, value, type, checked } = e.target;
      setIsLoading(true);
      const newRows = [...rows];
      newRows[index][name] = type === 'checkbox' ? checked : value;

      const newErrors = { ...errors };
      if (name === 'serialNo') {
         if (value.trim() !== '' && value.trim()?.length < 10) {
            newErrors[`serialNo_${index}`] = 'Serial number must be at least 10 characters.';
         } else {
            delete newErrors[`serialNo_${index}`];
         }
         setErrors(newErrors);
      }

      if (name === 'serialNo' && value.trim() !== '' && value.trim()?.length >= 10) {
         if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
         debounceTimeout.current = setTimeout(async () => {
            await handleSearch(value.trim(), index);

            const trimmedValue = value.trim();

            const isDuplicate = serial.includes(trimmedValue);

            if (isDuplicate) {
               toast.error(`Duplicate serial number: ${trimmedValue}`);
               newRows[index][name] = '';
               return;
            }
         }, 500);
      }
      if (name === 'serialNo' && value.trim() !== '' && value.trim()?.length >= 10) {
         if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
         debounceTimeout.current = setTimeout(async () => {
            await handleSearch(value.trim(), index);

            const trimmedValue = value.trim();

            const isDuplicate = otherSerial.includes(trimmedValue);

            if (isDuplicate) {
               toast.error(`Duplicate serial number: ${trimmedValue}`);
               newRows[index][name] = '';
               return;
            }
         }, 500);
      }
      setIsLoading(false);
      setRows(newRows);
      if (name === 'serialNo') {
         // delete errors[key];
         // setErrors(errors);
         setTimeout(() => {
            setSerial((prev) => {
               const updated = [...prev];
               updated[index] = value;
               return updated;
            });
         }, 600);
      }
   };

   const handlewarehouseChange = async (name, value, index) => {
      setIsLoading(true);
      const newRows = [...rows];
      newRows[index][name] = value;
      if (name === 'serialNo' && value.trim() !== '' && value.trim()?.length > 10) {
         if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
         debounceTimeout.current = setTimeout(async () => {
            await handleSearch(value.trim(), index);
         }, 500);
      }
      setIsLoading(false);
      setRows(newRows);
   };

   const handleKeyDown = (e, nextRef, preRef, index) => {
      if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
         e.preventDefault();
         const serialNumber = e.target.value.trim();
         const name = e.target.name;
         if (name === 'serialNo' && serialNumber === '') {
            const lastData = rows.filter((_, i) => i !== index);
            setRows(lastData);
            setItemStocks(lastData);
            submitRef.current.disabled = false;
            submitRef.current.focus();
            return;
         }
         if (name === 'note1') {
            if (nextRef && nextRef?.current) {
               nextRef?.current?.focus();
               return;
            }
         }
         if (nextRef && nextRef?.current) {
            nextRef?.current[index]?.focus();
            return;
         }
      }
      if (e.key === 'Tab' && e.shiftKey) {
         e.preventDefault();
         const serialNumber = e.target.value.trim();
         const name = e.target.name;
         if (name === 'serialNo' && preRef?.current[index - 1]) {
            preRef.current[index - 1].focus();
            return;
         }
         if (preRef && preRef?.current) {
            preRef?.current[index]?.focus();
            return;
         }
      }
   };

   const handleKeyDownSerial = (e, index) => {
      const allowedKeys = [
         'Backspace',
         'Tab',
         'Enter',
         'Escape',
         'ArrowLeft',
         'ArrowRight',
         'ArrowUp',
         'ArrowDown',
         'Delete',
         'Shift',
         'Control',
         'Alt',
         'Meta',
         'CapsLock',
         'Fn',
         'F1',
         'F2',
         'F3',
         'F4',
         'F5',
         'F6',
         'F7',
         'F8',
         'F9',
         'F10',
         'F11',
         'F12',
         ' ',
      ];

      const regex = /^[a-zA-Z0-9]$/; // Only letters and numbers allowed
      if (!regex.test(e.key) && !allowedKeys.includes(e.key)) {
         e.preventDefault(); // Stop typing the invalid character
         handleChange({ target: { name: 'serialNo', value: '' } }, index); // Clear input
         alert('Only letters and numbers are allowed');
      }
   };

   return (
      <>
         <Modal isOpen={isOpen} onClose={handleOnClose} size="6xl" isCentered onCloseComplete={onCloseComplete}>
            <ModalOverlay bg="blackAlpha.600" />
            <ModalContent
               bg={isDark ? '#1a202c' : '#ffffff'}
               borderRadius="24px"
               p={0}
               boxShadow={isDark ? '0 25px 50px -12px rgba(0, 0, 0, 0.8)' : '0 25px 50px -12px rgba(0, 0, 0, 0.25)'}
               border={isDark ? '1px solid #2d3748' : '1px solid #e2e8f0'}
               maxH="90vh"
               overflow="hidden">
               <ModalHeader
                  fontSize="24px"
                  fontWeight="700"
                  bg={
                     isDark
                        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                        : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                  }
                  color="white"
                  borderTopRadius="24px"
                  py={6}
                  px={8}
                  position="relative">
                  Add Serial Number
                  <ModalCloseButton
                     color="white"
                     top={6}
                     right={6}
                     _hover={{ bg: 'whiteAlpha.300' }}
                     borderRadius="full"
                  />
               </ModalHeader>
               <ModalBody
                  p={8}
                  overflowY="auto"
                  maxH="calc(90vh - 180px)"
                  css={{
                     '&::-webkit-scrollbar': {
                        width: '12px',
                     },
                     '&::-webkit-scrollbar-track': {
                        background: isDark ? '#1a202c' : '#f1f1f1',
                        borderRadius: '10px',
                     },
                     '&::-webkit-scrollbar-thumb': {
                        background: isDark ? '#667eea' : '#cbd5e0',
                        borderRadius: '10px',
                     },
                     '&::-webkit-scrollbar-thumb:hover': {
                        background: isDark ? '#764ba2' : '#a0aec0',
                     },
                  }}>
                  <Box width="100%">
                     {rows?.map((row, index) => (
                        <Box
                           key={index}
                           border={isDark ? '2px solid #4a5568' : '2px solid #e2e8f0'}
                           bg={isDark ? '#2d3748' : '#f7fafc'}
                           p="24px"
                           borderRadius="20px"
                           mb={6}
                           width="100%"
                           boxShadow={
                              isDark ? '0 4px 6px -1px rgba(0, 0, 0, 0.4)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                           }
                           transition="all 0.3s ease-in-out"
                           _hover={{
                              transform: 'translateY(-4px)',
                              boxShadow: isDark
                                 ? '0 10px 15px -3px rgba(102, 126, 234, 0.3)'
                                 : '0 10px 15px -3px rgba(102, 126, 234, 0.2)',
                           }}>
                           <Grid display="flex" gap={5} width="100%">
                              <GridItem gap={3} width="100%">
                                 <GridItem gap={3} display="flex" width="100%">
                                    <GridItem mb={3} width="50%">
                                       <InputField
                                          ref={(el) => (serialNoRef.current[index] = el)}
                                          type="text"
                                          name="serialNo"
                                          errorName={`serialNo_${index}`}
                                          label="Serial NO"
                                          value={row.serialNo}
                                          onChange={(e) => handleChange(e, index)}
                                          onKeyDown={(e) => {
                                             handleKeyDown(e, serialNo2Ref, note1Ref, index);
                                             handleKeyDownSerial(e, index);
                                          }}
                                          autoFocus={index === rows?.length - 1}
                                          errors={errors}
                                       />
                                    </GridItem>
                                    <GridItem width="50%">
                                       <InputField
                                          ref={(el) => (serialNo2Ref.current[index] = el)}
                                          type="text"
                                          name="serialNo2"
                                          label="Serial NO 2"
                                          value={row.serialNo2}
                                          onChange={(e) => handleChange(e, index)}
                                          onKeyDown={(e) => handleKeyDown(e, note1Ref, serialNoRef, index)}
                                       />
                                    </GridItem>
                                 </GridItem>
                                 <GridItem display="flex">
                                    <GridItem
                                       width="100%"
                                       mr={
                                          selectcompany?.setting?.warehouseWishStock === true && lineitemview === true
                                             ? 3
                                             : 0
                                       }>
                                       <InputField
                                          ref={(el) => (note1Ref.current[index] = el)}
                                          type="text"
                                          name="note1"
                                          label="Note"
                                          value={row.note1}
                                          onChange={(e) => {
                                             handleChange(e, index);
                                          }}
                                          onKeyDown={(e) => handleKeyDown(e, plusRef, serialNo2Ref, index)}
                                       />
                                    </GridItem>
                                    {selectcompany?.setting?.warehouseWishStock === true && lineitemview === true && (
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'warehouseId',
                                             'Ware House',
                                             warehouseList,
                                             {
                                                value: row.warehouseId,
                                                onChange: (value) => handlewarehouseChange('warehouseId', value, index),
                                                showCustomNoOptions: true,
                                                openfrom: 'wareHouse',
                                             },
                                             {},
                                             textColor,
                                             false,
                                             'Select Ware House',
                                          )}
                                       </GridItem>
                                    )}
                                 </GridItem>

                                 {/* New Switches Section */}
                                 <GridItem display="flex" gap={6} mt={4} width="100%">
                                    <FormControl
                                       display="flex"
                                       alignItems="center"
                                       justifyContent="space-between"
                                       bg={isDark ? '#1a202c' : 'white'}
                                       border={isDark ? '2px solid #667eea' : '2px solid #e2e8f0'}
                                       borderRadius="16px"
                                       p={4}
                                       minW="200px">
                                       <FormLabel
                                          htmlFor={`Box-${index}`}
                                          mb={0}
                                          fontSize="14px"
                                          fontWeight="600"
                                          color={isDark ? '#e2e8f0' : '#2d3748'}>
                                          Box
                                       </FormLabel>
                                       <Switch
                                          name="isBox"
                                          id={`Box-${index}`}
                                          isChecked={row.isBox}
                                          onChange={(e) => handleChange(e, index)}
                                          colorScheme="blue"
                                          size="lg"
                                       />
                                    </FormControl>

                                    <FormControl
                                       display="flex"
                                       alignItems="center"
                                       justifyContent="space-between"
                                       bg={isDark ? '#1a202c' : 'white'}
                                       border={isDark ? '2px solid #667eea' : '2px solid #e2e8f0'}
                                       borderRadius="16px"
                                       p={4}
                                       minW="180px">
                                       <FormLabel
                                          htmlFor={`bill-${index}`}
                                          mb={0}
                                          fontSize="14px"
                                          fontWeight="600"
                                          color={isDark ? '#e2e8f0' : '#2d3748'}>
                                          Bill
                                       </FormLabel>
                                       <Switch
                                          name="isBill"
                                          id={`bill-${index}`}
                                          isChecked={row.isBill}
                                          onChange={(e) => handleChange(e, index)}
                                          colorScheme="green"
                                          size="lg"
                                       />
                                    </FormControl>

                                    <FormControl
                                       display="flex"
                                       alignItems="center"
                                       justifyContent="space-between"
                                       bg={isDark ? '#1a202c' : 'white'}
                                       border={isDark ? '2px solid #667eea' : '2px solid #e2e8f0'}
                                       borderRadius="16px"
                                       p={4}
                                       minW="160px">
                                       <FormLabel
                                          htmlFor={`kit-${index}`}
                                          mb={0}
                                          fontSize="14px"
                                          fontWeight="600"
                                          color={isDark ? '#e2e8f0' : '#2d3748'}>
                                          Kit
                                       </FormLabel>
                                       <Switch
                                          name="isKit"
                                          id={`kit-${index}`}
                                          isChecked={row.isKit}
                                          onChange={(e) => handleChange(e, index)}
                                          colorScheme="orange"
                                          size="lg"
                                       />
                                    </FormControl>
                                 </GridItem>
                              </GridItem>
                              <GridItem display="flex" flexDirection="column" alignItems="center" gap={3}>
                                 <FormControl
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    bg={isDark ? '#1a202c' : 'white'}
                                    border={isDark ? '2px solid #667eea' : '2px solid #e2e8f0'}
                                    borderRadius="16px"
                                    p={4}
                                    minW="140px">
                                    <FormLabel
                                       htmlFor={`idOld-${index}`}
                                       style={{ textWrap: 'nowrap' }}
                                       mb={0}
                                       fontSize="14px"
                                       fontWeight="600"
                                       color={isDark ? '#e2e8f0' : '#2d3748'}
                                       mr={3}>
                                       Is Old
                                    </FormLabel>
                                    <Switch
                                       name="isOld"
                                       id={`idOld-${index}`}
                                       isChecked={row.isOld}
                                       onChange={(e) => handleChange(e, index)}
                                       colorScheme="purple"
                                       size="lg"
                                    />
                                 </FormControl>
                                 <Flex gap={2} width="100%" justifyContent="center">
                                    {rows?.length > 1 && (
                                       <Button
                                          bg={
                                             isDark
                                                ? 'linear-gradient(135deg, #f56565 0%, #c53030 100%)'
                                                : 'linear-gradient(135deg, #fc8181 0%, #f56565 100%)'
                                          }
                                          color="white"
                                          size="md"
                                          width="48px"
                                          height="48px"
                                          borderRadius="14px"
                                          onClick={() => removeRow(index)}
                                          fontSize="24px"
                                          fontWeight="700"
                                          _hover={{
                                             transform: 'scale(1.05)',
                                             boxShadow: isDark
                                                ? '0 6px 12px -2px rgba(245, 101, 101, 0.4)'
                                                : '0 6px 12px -2px rgba(245, 101, 101, 0.3)',
                                          }}
                                          _active={{
                                             transform: 'scale(0.95)',
                                          }}
                                          transition="all 0.2s ease-in-out"
                                          _focus={{ outline: 'none', boxShadow: '0 0 0 3px rgba(245, 101, 101, 0.3)' }}>
                                          -
                                       </Button>
                                    )}
                                    {index === rows?.length - 1 && (
                                       <Button
                                          ref={plusRef}
                                          bg={
                                             isDark
                                                ? 'linear-gradient(135deg, #48bb78 0%, #38a169 100%)'
                                                : 'linear-gradient(135deg, #68d391 0%, #48bb78 100%)'
                                          }
                                          color="white"
                                          size="md"
                                          width="48px"
                                          height="48px"
                                          borderRadius="14px"
                                          onClick={addRow}
                                          fontSize="24px"
                                          fontWeight="700"
                                          _hover={{
                                             transform: 'scale(1.05)',
                                             boxShadow: isDark
                                                ? '0 6px 12px -2px rgba(72, 187, 120, 0.4)'
                                                : '0 6px 12px -2px rgba(72, 187, 120, 0.3)',
                                          }}
                                          _active={{
                                             transform: 'scale(0.95)',
                                          }}
                                          transition="all 0.2s ease-in-out"
                                          _focus={{ outline: 'none', boxShadow: '0 0 0 3px rgba(72, 187, 120, 0.3)' }}>
                                          +
                                       </Button>
                                    )}
                                 </Flex>
                              </GridItem>
                           </Grid>
                        </Box>
                     ))}
                  </Box>
               </ModalBody>
               <ModalFooter
                  justifyContent="flex-end"
                  alignItems="center"
                  bg={isDark ? '#1a202c' : '#f7fafc'}
                  borderBottomRadius="24px"
                  py={6}
                  px={8}
                  borderTop={isDark ? '2px solid #4a5568' : '2px solid #e2e8f0'}>
                  <Flex gap={4}>
                     <Button
                        ref={submitRef}
                        bg={
                           isDark
                              ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                        }
                        color="white"
                        size="lg"
                        fontWeight="700"
                        fontSize="16px"
                        px={10}
                        borderRadius="14px"
                        onClick={() => handleSave()}
                        isDisabled={isLoading || !isSerialNo || isSaving}
                        isLoading={isLoading || isSaving}
                        _hover={{
                           transform: 'translateY(-2px)',
                           boxShadow: isDark
                              ? '0 10px 20px -5px rgba(102, 126, 234, 0.4)'
                              : '0 10px 20px -5px rgba(102, 126, 234, 0.3)',
                        }}
                        _active={{
                           transform: 'translateY(0)',
                        }}
                        transition="all 0.2s ease-in-out"
                        _focus={{ outline: 'none', boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.3)' }}>
                        {isSaving ? 'Saving...' : 'Save'}
                     </Button>
                     <Button
                        bg={
                           isDark
                              ? 'linear-gradient(135deg, #f56565 0%, #c53030 100%)'
                              : 'linear-gradient(135deg, #fc8181 0%, #f56565 100%)'
                        }
                        color="white"
                        onClick={() => handleOnClose()}
                        size="lg"
                        fontWeight="700"
                        fontSize="16px"
                        px={10}
                        borderRadius="14px"
                        _hover={{
                           transform: 'translateY(-2px)',
                           boxShadow: isDark
                              ? '0 10px 20px -5px rgba(245, 101, 101, 0.4)'
                              : '0 10px 20px -5px rgba(245, 101, 101, 0.3)',
                        }}
                        _active={{
                           transform: 'translateY(0)',
                        }}
                        transition="all 0.2s ease-in-out"
                        _focus={{ outline: 'none', boxShadow: '0 0 0 3px rgba(245, 101, 101, 0.3)' }}>
                        Cancel
                     </Button>
                  </Flex>
               </ModalFooter>
            </ModalContent>
         </Modal>
      </>
   );
};

export default SerialNumberModal;
